export type CrawlerPolicy = 'ALLOW_ALL' | 'BLOCK_ALL' | 'PER_BOT';

export type AieoDeclaration =
  | 'human-authored'
  | 'ai-assisted'
  | 'ai-generated'
  | 'mixed'
  | 'undeclared';

export interface AICrawlerBot {
  id: string;
  userAgent: string;
  label: string;
}

export interface AieoSettings {
  crawlerPolicy: CrawlerPolicy | null;
  perBot: Record<string, 'ALLOW' | 'DISALLOW'>;
  declaration: AieoDeclaration;
  trainingDataConsent: boolean;
  attributionUrl: string;
  llmsTextOverride: string;
}

export interface UpdateCustomAppAieoInput {
  customAppId: string;
  workspaceId: string;
  crawlerPolicy: CrawlerPolicy | null;
  crawlerPolicyDetails: Record<string, 'ALLOW' | 'DISALLOW'> | null;
  declaration: AieoDeclaration;
  trainingDataConsent: boolean;
  attributionUrl: string | null;
  llmsTextOverride: string | null;
}

export function buildUpdateCustomAppAieoInput(
  draft: AieoSettings,
  customAppId: string,
  workspaceId: string
): UpdateCustomAppAieoInput {
  return {
    customAppId,
    workspaceId,
    crawlerPolicy: draft.crawlerPolicy,
    crawlerPolicyDetails:
      draft.crawlerPolicy === 'PER_BOT' ? draft.perBot : null,
    declaration: draft.declaration,
    trainingDataConsent: draft.trainingDataConsent,
    attributionUrl:
      draft.attributionUrl.trim().length === 0
        ? null
        : draft.attributionUrl.trim(),
    llmsTextOverride:
      draft.llmsTextOverride.length === 0 ? null : draft.llmsTextOverride,
  };
}

export function normaliseCrawlerPolicyForDraft(
  crawlerPolicy: string | null | undefined
): CrawlerPolicy | null {
  return crawlerPolicy === 'BLOCK_ALL'
    ? 'BLOCK_ALL'
    : crawlerPolicy === 'PER_BOT'
      ? 'PER_BOT'
      : crawlerPolicy === 'ALLOW_ALL'
        ? 'ALLOW_ALL'
        : null;
}

export function buildRobotsPreview(
  draft: AieoSettings,
  bots: readonly AICrawlerBot[],
  slug: string
): string {
  const lines = ['User-agent: *'];
  if (draft.crawlerPolicy === null) {
    return [
      '# Uses workspace AI crawler policy',
      'User-agent: *',
      '',
      'Sitemap: /sitemap.xml',
    ].join('\n');
  }
  if (draft.crawlerPolicy === 'BLOCK_ALL') {
    lines.push(`Disallow: /p/${slug}`);
  }
  if (draft.crawlerPolicy === 'PER_BOT') {
    for (const bot of bots) {
      if (draft.perBot[bot.id] !== 'DISALLOW') continue;
      lines.push('', `User-agent: ${bot.userAgent}`, `Disallow: /p/${slug}`);
    }
  }
  lines.push('', 'Sitemap: /sitemap.xml');
  return lines.join('\n');
}
